import Vue from '../lib/utils/vue3compat/vue.js?vue3';
import VueApollo from '../lib/utils/vue3compat/vue_apollo.js?vue3';
import { initVueApp } from '../lib/utils/vue3compat/init_vue_app.js?vue3';
import apolloProvider from '../repository/graphql.js?vue3';
import FilePreview from '../repository/components/preview/index.vue?vue3';

Vue.use(VueApollo);

export const initGroupReadme = () => {
  const el = document.getElementById('js-group-readme');

  if (!el) return false;

  const { webPath, name } = el.dataset;

  return initVueApp({
    el,
    name: 'GroupFilePreviewRoot',
    apolloProvider,
    component: FilePreview,
    props: {
      blob: { webPath, name },
    },
  });
};
